import type { CanMatchFn } from '@angular/router';
import { environment } from '@environments/environment';

export const isNotProductionGuard: CanMatchFn = (): boolean => {
  return !environment.production;
};
